document.addEventListener("DOMContentLoaded", () => {
  // タイストアは刻印の納期に関する記載非表示
  var domain = window.location.hostname;
  var domainThaiFlag = false;
  if(domain == "th.bonaventura.shop"){
    domainThaiFlag = true;
  }
  var leadtimeText = document.getElementById('leadtimeText');
  if(domainThaiFlag){
    leadtimeText.style.display = 'none';
  }

  // const variantDataElement = document.querySelector("#variantData");
  // const variantImageElement = document.querySelector("#variantImage");
  // const variantData = JSON.parse(variantDataElement.textContent);

  // function getVariantFromCurrentUrl() {
  //   const currentUrl = window.location.href;
  //   const urlObj = new URL(currentUrl);
  //   const searchParams = new URLSearchParams(urlObj.search);
  //   return searchParams.get("variant");
  // }
  // function findVariantById(variantId) {
  //   return variantData.find((variant) => variant.id.toString() === variantId);
  // }
  // const openDrawer = document.querySelector("#openDrawerBtn");
  // openDrawer.addEventListener("click", () => {
  //   const variantNumber = getVariantFromCurrentUrl();
  //   const variant = findVariantById(variantNumber);
  //   if (variant) {
  //     const image = variant.featured_image.src;
  //     variantImageElement.src = image;
  //   } else {
  //     console.log("Variant not found.");
  //   }
  // });
});
